import type { ReactNode } from 'react'

export type SectionHeaderProps = {
  title: ReactNode
  action?: ReactNode
  kicker?: ReactNode
}

export const SectionHeader = ({ title, action, kicker }: SectionHeaderProps) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'baseline',
      justifyContent: 'space-between',
      padding: '12px 16px 6px',
    }}
  >
    <div>
      {kicker && <div className="kicker">{kicker}</div>}
      <div
        style={{
          fontFamily: 'var(--font-display)',
          fontWeight: 600,
          fontSize: 14,
          color: 'var(--ink)',
          letterSpacing: -0.2,
        }}
      >
        {title}
      </div>
    </div>
    {action}
  </div>
)
